<template>
  <div class="not-found-container">
    <div class="animation-container">
      <lottie-animation ref="anim" :animationData="require('/public/images/404.json')" loop />
    </div>
    <div class="not-found-info spacey-20">
      <h1 class="h1 text-primary">{{ $t('Page not found') }}</h1>
      <p class="text-lm text-primary">
        {{ $t('Sorry, the page you are looking for doesn’t exist or has been moved.') }}
      </p>
      <Button @click="routeToHome">{{ user ? $t('Go to my projects') : $t('Register') }}</Button>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import LottieAnimation from 'lottie-web-vue';
  import { mapState } from 'vuex';

  export default {
    name: 'PageNotFound',
    components: {
      Button,
      LottieAnimation,
    },
    computed: {
      ...mapState('auth', ['user']),
    },
    methods: {
      routeToHome() {
        this.$router.push({ name: 'login' });
      },
    },
  };
</script>

<style scoped>
  .not-found-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .not-found-info {
    text-align: center;
  }

  .animation-container {
    max-width: 500px;
  }
</style>
